<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/customers'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
import { CustomerDeliveryAddressService } from '../../../_services/api/customers/customer-delivery-address.service';
// import { RegionTabs, GetIndexByTabName } from "../../../_models/tabdata/settings/region-tabs";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      validationSummary: [],
      setLoading: false,
      formModel: {
        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Region",
        pageRoute: "/customer-region",
        saveEndPoint: "CustomerRegion",
        recordEndPoint: "CustomerRegion",
        isDefaultEndPoint: "Save_DefaultCustomerRegion",
        exportFileName: "Customer Region List",
        // selectedIndex: GetIndexByTabName("Customer Region"),
        // tabs: RegionTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerRegion",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "customer-region",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/customer-region/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              // /////////
              screenField: "CustomerRegion",
              dataField: "Code",
              label : "Region",
              allowHiding: false,
              sortOrder: "asc",
              sortIndex: 0,
            },
            {
              dataField: "ChangedBy",
              label: "Changed By",
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                var items = grid.getDataSource().items();
                var getDefault,
                  clickedDefault = undefined;
                if (items)
                  items.forEach((element) => {
                    if (element.Code == cellInfo.data.Code)
                      clickedDefault = element.Code;
                    if (element.IsDefault == "Y") getDefault = element.Code;
                  });

                if (!getDefault)
                  await SplitViewService.getIsDefault(
                    "CustomerRegion"
                  ).then((res) => {
                    if (res.data.value.length > 0)
                      getDefault = res.data.value[0].Code;
                  });

                let confirmLeaving = await this.$confirm(
                  `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
                  "Default Setting Change"
                );

                if (!confirmLeaving) {
                  event.component.beginUpdate();
                  event.component.option("value", false);
                  event.component.endUpdate();
                  return;
                }
                if (updateIsDefault) {
                  this.$store.dispatch("ui/setUpdateIsDefault", {
                    update: true,
                    code: cellInfo.data.Code,
                    event: event,
                  });
                }
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                label :{
                  text : "Region"
                },
                required: true,
                allowUpdate: this.baseView.mode == "edit" ? false : true,
                screenField: "Code",
                isPrimaryKeyField: true,
              },
            
              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        await CustomerDeliveryAddressService.getCustomRequest(
          `RegionCode eq '${this.formModel["Code"]}'`
        )
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.formModel["Code"]} is associated with Customer Delivery Address records. This may not be marked inactive until it is no longer associated with Customer Delivery Address records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated Customer Delivery Address use the filters on the Customer Delivery Address list.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
  },
};
</script>
